module.exports = __webpack_public_path__ + "static/media/google-g-logo.b9036f88.svg";